import { render, staticRenderFns } from "./card-title-description.vue?vue&type=template&id=9987a3d0&scoped=true&"
import script from "./card-title-description.vue?vue&type=script&lang=js&"
export * from "./card-title-description.vue?vue&type=script&lang=js&"
import style0 from "./card-title-description.vue?vue&type=style&index=0&id=9987a3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9987a3d0",
  null
  
)

export default component.exports